import { Anchor, Box, Breadcrumbs, Container, Divider, MantineStyleProp, ScrollArea, Text, useMatches } from "@mantine/core";
import { ReactNode, useEffect } from "react";
import { Link, useNavigate } from "react-router";

interface BasePageProps {
    title?: string;
    desc?: string;
    fullWidth?: boolean;
    withDivider?: boolean;
    style?: MantineStyleProp;
    breadcrumbs?: BreadcrumbItem[];
    hideHomeCrumb?: boolean;
    children: ReactNode;
}

interface BreadcrumbItem {
    label: string;
    previousPage?: boolean;
}

function BasePage({ title, desc, fullWidth = false, withDivider = false, style, breadcrumbs = [], hideHomeCrumb, children }: BasePageProps) {
    const navigate = useNavigate();
    const isHomePage = (): boolean => {
        const segments = window.location.pathname.split("/").filter(Boolean);
        return segments.length === 0;
    };

    const normalWidthMatches = useMatches({
        base: "100%",
        lg: "60%"
    });

    const fullWidthMatches = useMatches({
        base: "100%",
        lg: "100%"
    });

    const items = [
        !isHomePage() && !hideHomeCrumb && (
            <Anchor component={Link} to="/" key="home">
                Home
            </Anchor>
        ),
        ...breadcrumbs.map((crumb, i) =>
            crumb.previousPage ? (
                <Anchor key={i} onClick={() => navigate(-1)}>
                    {crumb.label}
                </Anchor>
            ) : (
                <span key={i}>{crumb.label}</span>
            )
        ),
    ];

    useEffect(() => {
        document.title = title ?? "Unify";
    }, [document.title]);

    return (
        <Container p={16} size={fullWidth ? fullWidthMatches : normalWidthMatches} style={{
            ...style,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            position: "relative",
        }}>
            <Box mb={16}>
                <Breadcrumbs mb={16}>
                    {items}
                </Breadcrumbs>

                <Text fw={600} size="24px" mb={8}>
                    {title}
                </Text>
                <Text c="var(--text-dimmed)" size="14px">
                    {desc}
                </Text>
            </Box>

            {withDivider && <Divider mb={16} />}

            <ScrollArea h={"calc(100vh - 185px)"} scrollbarSize={"2px"} offsetScrollbars>
                {children}
            </ScrollArea>
        </Container>
    )
}

export default BasePage;